import { Stack, Typography } from "@mui/material";
import React from "react";
import StatusChip from "@entrilia/shared/components/StatusChip";
import { tagColorToThemeColorMap } from "@entrilia/shared/utilities/colorHelper";
import type { TabularReportCellValueData } from "./tabularReportCellValuesHelper";

interface Props {
  cellValues: TabularReportCellValueData[];
}

const TabularReportCellValuesList = ({ cellValues }: Props) => {
  return (
    <>
      {cellValues.map(({ column, cell }) => (
        <React.Fragment key={column.id}>
          <Stack direction="row" spacing={1} sx={{ alignItems: "flex-start", minWidth: 0, maxWidth: "100%" }}>
            <Typography color="textSecondary" sx={{ flex: 1, minWidth: 0, width: 0 }}>
              {column.title}
            </Typography>

            {cell?.tagColor ? (
              <StatusChip label={cell.formattedValue} color={tagColorToThemeColorMap[cell.tagColor]} />
            ) : (
              <Typography sx={{ flex: 1, minWidth: 0, width: 0, textAlign: "right" }}>
                {cell?.formattedValue || "-"}
              </Typography>
            )}
          </Stack>

          {cell?.subValue && (
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ minWidth: 0, maxWidth: "100%", textAlign: "right" }}
            >
              {cell.subValue}
            </Typography>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

export default TabularReportCellValuesList;
